module.exports = require("next/dist/client/components/action-async-storage.external.js");